<template>
  <div>
    <div class="rel_title">Gráficos</div>

    <div class="d-flex graphics">
      <pie-chart
        v-if="chartDataAndamentosPerguntas"
        :chart-data="chartDataAndamentosPerguntas"
        :options="chartOptionsPerguntas"
        :width="300"
        :height="300"
      >
      </pie-chart>

      <template v-if="!isSala">
        <pie-chart
          v-if="chartDataEncontros"
          :chart-data="chartDataEncontros"
          :options="chartOptionsEncontros"
          :width="300"
          :height="300"
        >
        </pie-chart>

        <pie-chart
          v-if="chartDataRelatoriosAdm"
          :chart-data="chartDataRelatoriosAdm"
          :options="chartOptionsAmin"
          :width="300"
          :height="300"
        >
        </pie-chart>

        <pie-chart
          v-if="chartDataRelatorios"
          :chart-data="chartDataRelatorios"
          :options="chartOptionsRelatorios"
          :width="300"
          :height="300"
        >
        </pie-chart>
      </template>
    </div>
  </div>
</template>
<script>
import PieChart from "@/components/chart/PieChart";
import { administrativeDashboardAPI } from "@/modules/administrative-dashboard";
import { mapActions, mapGetters } from "vuex";
const INITIAL_FILTER_VALUES = {
  municipioId: [],
  usuarioId: null,
  grupoSolucaoId: null,
  dataInicial: null,
  dataFim: null,
  solucaoId: [],
  statusId: null,
  id_unidade_regional: [],
  uf: [],
  eixosIds: [],
  temaId: [],
};
export default {
  components: {
    PieChart,
  },
  props: {
    isGraphic: false,
  },
  computed: {
    ...mapGetters(["isSala"]),
  },
  data() {
    return {
      chartDataEncontros: {},
      chartDataAndamentosPerguntas: {},
      chartDataRelatoriosAdm: {},
      chartDataRelatorios: {},
      chartOptionsEncontros: {
        hoverBorderWidth: 10,
        title: {
          display: true,
          fontSize: 14,
          text: "Eventos",
        },
      },
      chartOptionsPerguntas: {
        hoverBorderWidth: 10,
        title: {
          display: true,
          fontSize: 14,
          text: "",
        },
      },
      chartOptionsAmin: {
        hoverBorderWidth: 10,
        title: {
          display: true,
          fontSize: 14,
          text: "Relatórios Adm",
        },
      },
      chartOptionsRelatorios: {
        hoverBorderWidth: 10,
        title: {
          display: true,
          fontSize: 14,
          text: "Relatórios",
        },
      },
    };
  },
  mounted() {
    this.getDashboard();
    this.chartOptionsPerguntas.title.text = this.isSala
      ? "Status Geral"
      : "Andamentos Perguntas";
  },
  methods: {
    ...mapActions(["setLoading"]),
    getDashboard() {
      this.setLoading(true);
      administrativeDashboardAPI
        .getDashboard(INITIAL_FILTER_VALUES)
        .then(({ data: relatorio }) => {
          this.fillChartEncontros(relatorio.graficoEventos);
          this.fillChartRelatorios(relatorio.graficoRelatorios);
          this.fillChartRelatoriosAdm(
            relatorio.graficoRelatoriosAdministrativos
          );
          this.fillChartAndamentosPerguntas(relatorio.graficoPerguntas);
          this.setLoading(false);
        })
        .catch((erro) => {
          console.log("erro getDashboard: ", erro);
          this.setLoading(false);
          this.$notification.error("Erro ao buscar dados do dashboard");
        });
    },
    fillChartEncontros(payload) {
      this.chartDataEncontros = {
        labels: [payload[0].label, payload[1].label],
        datasets: [
          {
            backgroundColor: ["#FF5722", "#009688"],
            data: [payload[0].valor, payload[1].valor],
          },
        ],
      };
    },
    fillChartRelatorios(payload) {
      this.chartDataRelatorios = {
        labels: [
          payload[0].label,
          payload[1].label,
          payload[2].label,
          payload[3].label,
        ],
        datasets: [
          {
            backgroundColor: ["#FFC107", "#00796B", "#D32F2F", "#607D8B"],
            data: [
              payload[0].valor,
              payload[1].valor,
              payload[2].valor,
              payload[3].valor,
            ],
          },
        ],
      };
    },
    fillChartRelatoriosAdm(payload) {
      this.chartDataRelatoriosAdm = {
        labels: [
          payload[0].label,
          payload[1].label,
          payload[2].label,
          payload[3].label,
        ],
        datasets: [
          {
            backgroundColor: ["#FFC107", "#00796B", "#D32F2F", "#607D8B"],
            data: [
              payload[0].valor,
              payload[1].valor,
              payload[2].valor,
              payload[3].valor,
            ],
          },
        ],
      };
    },
    fillChartAndamentosPerguntas(payload) {
      this.chartDataAndamentosPerguntas = {
        labels: [
          payload[0].label,
          payload[1].label,
          payload[2].label,
          payload[3].label,
          payload[4].label,
        ],
        datasets: [
          {
            backgroundColor: [
              "#FFC107",
              "#00796B",
              "#D32F2F",
              "#607D8B",
              "#ccc",
            ],
            data: [
              payload[0].valor,
              payload[1].valor,
              payload[2].valor,
              payload[3].valor,
              payload[4].valor,
            ],
          },
        ],
      };
    },
  },
};
</script>
<style scoped lang="scss">
.graphics {
  flex-wrap: wrap;
  column-gap: 3rem;
  row-gap: 3rem;
  justify-content: space-around;
}

.rel_title {
  background: var(--corPrimaria);
  color: #fff;
  padding: 1rem;
  text-align: center;
}
</style>
